//Pagina de perfil
import React from "react";
import ProfileComponent from "../components/ProfileComponent";
const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3005';
export default function ProfilePage() {
  const [profileData, setProfileData] = React.useState(null);
  const [companiesData, setCompaniesData] = React.useState([]);
  const [projectsData, setProjectsData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('No estás autenticado. Por favor, inicia sesión.');
        window.location.href = '/';
        return;
      }

      try {
        setLoading(true);
        //Sacamos del localStorage el userId
        const userId = localStorage.getItem('userId');
        console.log('Fetching profile for userId:', userId);
        const response = await fetch(`${baseUrl}/users/${userId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();
        console.log('Response data:', data);

        if (!response.ok) {
          alert(data.message || 'Error al obtener el perfil');
          window.location.href = '/';
          return;
        }

        setProfileData(data);

        //Ahora recuperamos las empresas, en data.companies y para cada una de ellas
        if (data.companies && data.companies.length > 0) {
          const companies = await Promise.all(
            data.companies.map(async (company) => {
              console.log('Fetching company for companyId:', company.companyId);

              const res = await fetch(`${baseUrl}/company/${company.companyId}`, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`,
                },
              });

              const companyData = await res.json();

              // Combina los datos del fetch con el role original
              return {
                ...companyData,
                role: company.role,
              };
            })
          );

          setCompaniesData(companies); // actualiza el estado con los datos completos
        } else {
          setCompaniesData([]);
        }
        //Hacemos lo mismo para los proyectos
        if (data.projects && data.projects.length > 0) {
          const projects = await Promise.all(
            data.projects.map(async (project) => {
              console.log('Fetching project for projectId:', project.projectId);

              const res = await fetch(`${baseUrl}/project/${project.projectId}`, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`,
                },
              });

              const projectData = await res.json();

              // Combina los datos del fetch con el role original
              return {
                ...projectData,
                role: project.role,
              };
            })
          );
          setProjectsData(projects); // actualiza el estado con los datos completos
        } else {
          setProjectsData([]);
        }

      } catch (error) {
        console.error('Error en la petición:', error);
        alert('Error de conexión con el servidor');
      }
      finally {
        setLoading(false);
      }
    };


    fetchProfile();
  }, []);

  return React.createElement(ProfileComponent, { profile: profileData, companies: companiesData, projects: projectsData, loading: loading });
}